import React from "react";
import { TouchableOpacity, Text, StyleSheet } from "react-native";
import { BRAND_COLORS, TEXT_COLORS } from "../../style/colors.js";

const SaveButton = ({ onPress }) => {
  return (
    <TouchableOpacity onPress={onPress} style={styles.button}>
      <Text style={styles.text}>Save</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: BRAND_COLORS.PRIMARY_DARK,
    borderRadius: 10,
    padding: 8,
    width: "100%",
    marginLeft: 10,
    alignItems: "center",
  },
  text: {
    color: TEXT_COLORS.LIGHT,
    fontWeight: "bold",
    fontSize: 15,
  },
});

export default SaveButton;
